import { c as _c } from "react/compiler-runtime";
import { lngLatToMercatorMeters, VISUAL_REVEAL_RADIUS_METERS } from '@repo/map-preferences/fog-tiles';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectFilteredMapLocations, selectFogCircles, selectFogOfWarActive, selectMapConfig, selectTrackedCompassLocation } from '@repo/store/maps/slices/mapData';
import type { MapDataLocationFeature } from '@repo/types/maps/map-types';
import { useMemo } from 'react';
import { useMapCompassEnabled } from '../compass/use-map-compass-enabled';
import { getIsDedicatedMiniMap } from '../utils/mini-map-mode';
import { fogSpatialIndex } from './fog-spatial-index';

// 1.1× to match the shader's feathered outer edge — a 1.0× cutoff hides pins in visibly-revealed terrain.
const PIN_REVEAL_RADIUS = VISUAL_REVEAL_RADIUS_METERS * 1.1;
const REVEAL_RADIUS_SQ = PIN_REVEAL_RADIUS * PIN_REVEAL_RADIUS;
function applyFogFilter(filteredLocations: MapDataLocationFeature[], fogActive: boolean, circlesLen: number): MapDataLocationFeature[] {
  if (!fogActive) return filteredLocations;
  if (circlesLen === 0) return [];
  return filteredLocations.filter(loc => {
    if (loc.geometry.type !== 'Point') return false;
    const [lng, lat] = loc.geometry.coordinates;
    const [pmx, pmy] = lngLatToMercatorMeters(lng, lat);
    return fogSpatialIndex.hasNeighborWithin(pmx, pmy, REVEAL_RADIUS_SQ);
  });
}
export function useMapVisibleLocations() {
  const $ = _c(7);
  const filteredLocations = useAppSelector(selectFilteredMapLocations);
  const fogActive = useAppSelector(selectFogOfWarActive);
  const mapConfig = useAppSelector(selectMapConfig);
  const trackedCompassLocation = useAppSelector(selectTrackedCompassLocation);
  const mapCompassEnabled = useMapCompassEnabled();
  const isDedicatedMiniMap = getIsDedicatedMiniMap(mapConfig);
  const circles = useAppSelector(selectFogCircles);
  let t0;
  bb0: {
    if (isDedicatedMiniMap) {
      let t1;
      if ($[0] !== mapCompassEnabled || $[1] !== trackedCompassLocation) {
        t1 = mapCompassEnabled && trackedCompassLocation ? [trackedCompassLocation] : [];
        $[0] = mapCompassEnabled;
        $[1] = trackedCompassLocation;
        $[2] = t1;
      } else {
        t1 = $[2];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[3] !== circles.length || $[4] !== filteredLocations || $[5] !== fogActive) {
      t1 = applyFogFilter(filteredLocations, fogActive, circles.length);
      $[3] = circles.length;
      $[4] = filteredLocations;
      $[5] = fogActive;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = t1;
  }
  return t0;
}